import { SourcingSharedJobInformationStep } from 'modules/sourcing-shared/shared-steps';
import { getSourcingExternalHeaderBreadcrumbs } from 'modules/sourcing-external/utils';
import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { useShallow } from 'zustand/react/shallow';

export const SourcingExternalJobInformationStep = () => {
  const {
    candidateBatch,
    onJobInformationBack,
    onJobInformationNext,
    jobInformationFormData,
    setStep
  } = useSourcingExternalStore(
    useShallow((state) => ({
      candidateBatch: state.candidateBatch,
      onJobInformationBack: state.onJobInformationBack,
      onJobInformationNext: state.onJobInformationNext,
      jobInformationFormData: state.jobInformationFormData,
      setStep: state.setStep
    }))
  );

  const defaultFormData = jobInformationFormData || {
    jobTitle: candidateBatch?.jobDescriptionParsed?.jobTitle || '',
    employerName: candidateBatch?.jobDescriptionParsed?.employerName || '',
    location: candidateBatch?.jobDescriptionParsed?.location || '',
    contractType: candidateBatch?.jobDescriptionParsed?.contractType || '',
    additionalContext: ''
  };

  return (
    <SourcingSharedJobInformationStep
      headerBreadcrumbs={getSourcingExternalHeaderBreadcrumbs({
        candidateBatchJobTitle:
          candidateBatch?.jobDescriptionParsed?.jobTitle ?? '',
        candidateBatchId: candidateBatch?.id ?? '',
        setStep
      })}
      defaultFormData={defaultFormData}
      onJobInformationBack={onJobInformationBack}
      onJobInformationNext={onJobInformationNext}
    />
  );
};
